<template>
    <BaseSelect
        v-if="dateOptions"
        v-model="selectedValue"
        :options="null"
        class="filter-date-select"
        @input="updateFilterState"
    >
        <template #default>
            <option
                value="null"
                :selected="!selectedValue"
            >
                Altijd
            </option>

            <optgroup
                v-for="(group, groupIndex) in dateOptions"
                :key="`group_${groupIndex}`"
                :label="group.label"
            >
                <option
                    v-for="option in group.options"
                    :key="option.value"
                    :value="option.value"
                    :selected="option.value.toString() === selectedValue"
                >
                    {{ option.label }}
                </option>
            </optgroup>
        </template>

        <template #pre>
            <BaseIcon icon="date" />
        </template>
    </BaseSelect>
</template>

<script setup lang="ts">
import dateOptions from '~/constants/dateOptions';
import { useEventFiltersStore } from '~/stores/eventFilters';

const route = useRoute();

const eventFiltersStore = useEventFiltersStore();

const selectedValue = computed(() => {
    if (route.query.startDate) {
        return route.query.startDate as string;
    }

    return null;
});

function isNull(value: string|null) {
    if (
        !value
        || (
            typeof value === 'string' && value === 'null'
        )
    ) {
        return true;
    }

    return false;
}

const updateFilterState = async(newValue: string|null) => {
    const newRoute = {
        path: route.path,
        query: { ...route.query }
    };

    if (isNull(newValue as string|null)) {
        delete newRoute.query.startDate;
    } else {
        newRoute.query.startDate = newValue;
    }

    // If homepage, redirect to main programme entry containing filters
    if (route.name === 'index' && eventFiltersStore.mainProgramEntry) {
        newRoute.path = eventFiltersStore.mainProgramEntry.uri as string;
    }

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

    await navigateTo(newRoute);
};
</script>

<style lang="less" src="./FilterDateSelect.less" />
